import "zod/compile";
import { z } from "zod";
import {
  KpiComponentSchema,
  TableComponentSchema,
  TextComponentSchema,
  VegaChartComponentSchema,
} from "./queryReport";

/**
 * A whole widget as a person or an agent writes it for a surface that builds
 * its widgets from data sources (a template-backed dashboard): a KPI, Table,
 * Text block or custom chart, each refusing fields its type doesn't have so
 * a typo is reported rather than dropped. A surface checks the widget's
 * `source` with its catalog's own validator on top of this.
 */
export const ReportWidgetSchema = z.discriminatedUnion("type", [
  KpiComponentSchema.strict(),
  TableComponentSchema.strict(),
  TextComponentSchema.strict(),
  VegaChartComponentSchema.strict(),
]);
export type ReportWidget = z.infer<typeof ReportWidgetSchema>;
/** A widget as written, before defaults. */
export type ReportWidgetInput = z.input<typeof ReportWidgetSchema>;
export type ReportWidgetType = ReportWidget["type"];
